import React, { useContext } from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
import { EventContext, OfferOptionsContext } from "@gp/components";

import { useIsAdditionalOfferVisible } from "@utils/offer";
import { BetBuilderActionsTypeEnum } from "@data-types/analytics-tracker/BetBuilderInteractionTypeEnum";
import { analyticsTracker } from "@utils/analytics";

export default observer(function BetBuilderButton(props: {
	isOfferButton?: boolean;
	isOnHomepage?: boolean;
}) {
	const { isOfferButton = false, isOnHomepage } = props;

	const event = useContext(EventContext);
	const isAdditionalOfferVisible = useIsAdditionalOfferVisible();

	const {
		//@ts-expect-error
		additionalOfferToggle,
	} = useContext(OfferOptionsContext);

	//#region css
	if (!event.betBuilder) {
		return null;
	}
	// class order matters here
	const buttonClasses = classNames(
		{
			offer__actions__btn: isOfferButton && !isOnHomepage,
			event__actions__btn: !isOfferButton,
		},
		"btn",
		{
			"btn--square--reset btn--ghost": isOfferButton,
			"btn--square btn--square--xsml btn--ghost": !isOfferButton,
		}
	);

	const iconClasses = classNames(
		{
			offer__actions__icon: !isAdditionalOfferVisible,
			event__actions__icon: isAdditionalOfferVisible,
		},
		"u-icon u-icon--bb--active",
		{
			// "u-icon--sml": isOnHomepage,
			"u-icon--sml": isOfferButton,
			"u-icon--med": !isOfferButton,
			// "u-icon--bb--selected": !isHover,
			// "u-icon--bb--active": isHover,
		}
	);

	//#endregion css

	return (
		<button
			onClick={() => {
				analyticsTracker.trackBetBuilderInteraction(
					BetBuilderActionsTypeEnum.OpenBBwithShortcut
				);
				additionalOfferToggle(event, true);
			}}
			data-tooltip-id="bet-builder"
			data-tooltip-content={"betBuilder"}
			data-tooltip-position-strategy="fixed"
			className={buttonClasses}
			type="button"
		>
			<i className={iconClasses} />
		</button>
	);
});
